import { render } from "./YtNews.vue?vue&type=template&id=387ae60a&scoped=true"
import script from "./YtNews.vue?vue&type=script&lang=js"
export * from "./YtNews.vue?vue&type=script&lang=js"

import "./YtNews.vue?vue&type=style&index=0&id=387ae60a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387ae60a"]])

export default __exports__